export default {
  success: {
    successfully: '{key}に成功しました',
    copyToClipboard: 'クリップボードにコピーしました',
    approved: '{key}は承認されました',
    processed: '{key}処理が完了しました',
    uploaded: '{key}のアップロードが完了しました',
    register: '登録が成功しました、ログインしてください',
  },
  warning: {
    rejected: '{key}が拒否されました',
    removeFxRateTemplate: '注意：これにより、{name}のテンプレートは顧客、機関、代理店から削除されます。',
    transferFromIt: '本当に {from} から {to} へ残高のすべて [ 予測：{amount} ] を移動しますか？',
    clearBrowserCache: 'これにより、ブラウザのキャッシュがクリアされ、次のデフォルト設定に戻ります：',
    forcedRefresh: '*注意：現在のページは強制的に更新されます！',
    resetPassword1: '以下にメールを送信します',
    resetPassword2: '{email}',
    resetPassword3: 'アカウントの復元をお手伝いします',
  },
  error: {
    required: '必須項目です',
    duplicatedBy: '{target}と同じであってはいけません',
    symbolExisted: 'このシンボルは既に存在します',
    failed: '{key}に失敗しました',
    serverUnavailable: 'サーバーが利用できません。後でもう一度試してみてください',
    uploadFileType: 'ファイルタイプは{types}のみアップロードできます',
    uploadFileSize: 'ファイルサイズは{maxSize}MBを超えてはいけません',
    uploadFailed: 'アップロードに失敗しました',
    underLength: '長さが不足しています [{min}]',
    overLength: '長さが制限を超えています [{max}]',
    decimalOverLength: '長さが制限を超えています [{precision}, {scale}]',
    underflow: '最小値より小さいです [{min}]',
    overflow: '最大値を超えています [{max}]',
    invalidMailFormat: '無効なメール形式です',
    invalidMobileFormat: '無効な携帯電話番号',
    notOnlyNumber: '数字のみではいけません',
    notOnlyLetter: '文字のみではいけません',
    atLeastOneLowercase: '少なくとも1つの小文字が必要です',
    atLeastOneUppercase: '少なくとも1つの大文字が必要です',
    atLeastOneNumber: '少なくとも1つの数字が必要です',
    onlyAlphanumerical: '数字と文字の組み合わせが必要です',
    cannotBeSuperuser: 'スーパーユーザーにはなれません',
    mustBeSuperuser: 'スーパーユーザーでなければいけません',
    mustBeGreaterThan: '{number}以上である必要があります',
    ranges: '値の範囲：{min} ～ {max}',
    lengthLimit: '長さは {length} でなければいけません',
    notSame: '2回のパスワード入力が一致しません',
    notBlank: '空白ではありません',
    containsSpace: 'スペースを含めることはできません',
  },
  confirm: {
    title: '{action}を確認しますか？',
    resourceNotFoundTitle: 'リソースが見つかりません',
    resourceNotFoundContent: 'ページをリフレッシュして最新のリソースを取得しますか？',
  },
  modal: {
    add: '{name}を追加',
    edit: '{name}を編集',
    detail: '{name}の詳細',
  },
  pagination: {
    showTotal: `{start}-{end} 全 {total} レコード`,
  },
  tooltip: {
    settings: 'これらの設定はブラウザのキャッシュに保存されます',
  },
  message: {
    itReceiveCheck: '機関受け取りアカウントの検証が完了しました',
    needToCreateUsdReceiveAccount:
      '機関受け取りアカウントの検証に失敗しました、"ドル"の受け取りアカウントを作成する必要があります',
  },
};
